var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoBioregions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.242,
    height: 37.067,
    viewBox: "0 0 45.242 37.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_206",
    "data-name": "Groupe 206",
    transform: "translate(1174.727 -1008.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M-1156.5,1044.89l-3.916-3.15-.694-1.457-2.6-.278.787-2.1,1.409-1.115-.629-.489a11.672,11.672,0,0,0-1.7.288c.026.605-.012,1.587-.027,1.932l0,.084-.923,2.673-8.987-3.521,4.676-4.126,1.556-1.334,1.7-3.122-3.845-4.406,4.3-3.748,2.867.478,1.469,2.449,3.407,2.283,1.024-.881-2.93-1.953.462-3.14,3.476-5.049,5.622-1.028-2.178-2.6,3.8-2.6,8.84,5.809-1.989,6.92,1.674,2.678,4.087.881,3.624-1.49,2.005,1.416-3.646,6.7-6.858,5.343-2.312.723-.641,1.747,1.242,1.508-2.531,2.126-8.046.473Zm-2.978-3.891,3.23,2.6,3.111-.941.069,0,7.729-.455,1.352-1.136-.933-1.133,1.068-2.913,2.659-.831,6.5-5.064,3.034-5.574-.635-.449-3.366,1.384-4.922-1.061-2.21-3.536,1.9-6.594-7.47-4.909-2.1,1.436,2.638,3.149-7.115,1.3-3.048,4.427-.315,2.142,3.594,2.4-2.86,2.459-4.36-2.921-1.327-2.211-1.793-.3-3,2.62,3.611,4.138-2.186,4.023-1.713,1.468-3.239,2.858,6.08,2.382.471-1.365a17.39,17.39,0,0,0,.009-1.951.678.678,0,0,1,.126-.543c.112-.15.409-.548,2.878-.772l.229-.021,2.166,1.684-2.319,1.836-.145.387,1.751.188Z",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBioregions);
export default __webpack_public_path__ + "static/media/picto-bioregions.16f3cab23e29d87f826d4addb6f2150c.svg";
export { ForwardRef as ReactComponent };